import { refresh } from '../utils';

export const errorRoute = {
  name: 'error',
  path: '/error',
  component: () => refresh(import('@/views/Error.vue')),
  props: true,
};

export const initPurchaseAuthRoute = {
  path: '/init-purchase/auth',
  component: () => refresh(import('@/views/InitPurchaseAuth.vue')),
  meta: {
    layout: 'minimal',
  },
};

export const purchaseProcessingRoute = {
  path: '/process-purchase',
  component: () => refresh(import('@/views/ProcessPurchase.vue')),
  meta: {
    layout: 'minimal',
  },
};

export const appInstallationRoute = {
  path: '/install',
  component: () => refresh(import('@/views/Install.vue')),
};
